"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Coverage {
    constructor(data) {
        this.usedDataToCalc = {};
        this.currency = data.currency;
        this.calculatedTransitPremium = data.calculatedTransitPremium;
        this.otherPremiumCharges = data.otherPremiumCharges;
        this.warRate = data.warRate;
        this.totalTransitPremium = data.totalTransitPremium;
        this.minimumRuleApplied = data.minimumRuleApplied || false;
        this.toBeDefined = data.toBeDefined || false;
        this.flatCharges = data.flatCharges || [];
        this.validationsHighlight = data.validationsHighlight || [];
        this.usedDataToCalc = data.usedDataToCalc;
    }
    static empty() {
        const data = {
            currency: undefined,
            calculatedTransitPremium: undefined,
            otherPremiumCharges: undefined,
            warRate: undefined,
            totalTransitPremium: undefined,
            minimumRuleApplied: false,
            toBeDefined: true,
            flatCharges: [],
            validationsHighlight: [],
            usedDataToCalc: undefined
        };
        return new Coverage(data);
    }
    static fromObj(data) {
        if (!data) {
            return Coverage.empty();
        }
        return new Coverage(Object.assign({}, data));
    }
}
exports.default = Coverage;
//# sourceMappingURL=coverage.class.js.map